
import { createSlice } from '@reduxjs/toolkit'
import { runsheetUnassignedTablesAdapter } from '../adapters/runsheetUnassignedTablesAdapter'

export const initialRunsheetUnassignedTableState = runsheetUnassignedTablesAdapter.getInitialState()

export const runsheetUnassignedTablesSlice = createSlice({
  name: 'runsheetUnassignedTables',
  initialState: initialRunsheetUnassignedTableState,
  reducers: {
    upsertMultipleRunsheetUnassignedTables: (state, action) => {
      runsheetUnassignedTablesAdapter.upsertMany(state, action.payload)
    },
    upsertOneRunsheetUnassignedTable: (state, action) => {
      runsheetUnassignedTablesAdapter.upsertOne(state, action.payload)
    },
    setRunsheetUnassignedTableLoading: (state, action) => {
      const { id, isLoading } = action.payload
      const existingUnassignedTable = state.entities[id]
      
      if (existingUnassignedTable) {
        existingUnassignedTable.isLoading = isLoading
      }
    },
  },
})

export const { upsertMultipleRunsheetUnassignedTables, upsertOneRunsheetUnassignedTable, setRunsheetUnassignedTableLoading } = runsheetUnassignedTablesSlice.actions
